
import BaseAboshopWidget from '../../../../base/components/sidebar/widgets/AboshopWidget.vue'

export default class AboshopWidget extends BaseAboshopWidget {}
